/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthSubmissionStatusUpdatedByUserUserType } from './PalAuthSubmissionStatusUpdatedByUserUserType';
import {
    PalAuthSubmissionStatusUpdatedByUserUserTypeFromJSON,
    PalAuthSubmissionStatusUpdatedByUserUserTypeFromJSONTyped,
    PalAuthSubmissionStatusUpdatedByUserUserTypeToJSON,
    PalAuthSubmissionStatusUpdatedByUserUserTypeToJSONTyped,
} from './PalAuthSubmissionStatusUpdatedByUserUserType';

/**
 * 
 * @export
 * @interface PalAuthSubmissionStatusUpdatedByUser
 */
export interface PalAuthSubmissionStatusUpdatedByUser {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    last_name?: string;
    /**
     * 
     */
    title?: string;
    /**
     * 
     */
    user_type?: PalAuthSubmissionStatusUpdatedByUserUserType;
    /**
     * 
     */
    photo_url?: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionStatusUpdatedByUser interface.
 */
export function instanceOfPalAuthSubmissionStatusUpdatedByUser(value: object): value is PalAuthSubmissionStatusUpdatedByUser {
    return true;
}

export function PalAuthSubmissionStatusUpdatedByUserFromJSON(json: any): PalAuthSubmissionStatusUpdatedByUser {
    return PalAuthSubmissionStatusUpdatedByUserFromJSONTyped(json, false);
}

export function PalAuthSubmissionStatusUpdatedByUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionStatusUpdatedByUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'title': json['title'] == null ? undefined : json['title'],
        'user_type': json['user_type'] == null ? undefined : PalAuthSubmissionStatusUpdatedByUserUserTypeFromJSON(json['user_type']),
        'photo_url': json['photo_url'] == null ? undefined : json['photo_url'],
    };
}

export function PalAuthSubmissionStatusUpdatedByUserToJSON(json: any): PalAuthSubmissionStatusUpdatedByUser {
    return PalAuthSubmissionStatusUpdatedByUserToJSONTyped(json, false);
}

export function PalAuthSubmissionStatusUpdatedByUserToJSONTyped(value?: PalAuthSubmissionStatusUpdatedByUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'title': value['title'],
        'user_type': PalAuthSubmissionStatusUpdatedByUserUserTypeToJSON(value['user_type']),
        'photo_url': value['photo_url'],
    };
}

